import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './app';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/styles.scss';

import { Notificaiton } from './components/index';
import { store } from './stores/storeConfig';
import { injectStore } from './stores/services/commonApis';

// async function defeRender() {
//   const { worker } = await import('./pages/auth/dashboard/mocks/browser');
//   return worker.start();
// }

async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.register('/service-worker.js');
  }
  return null;
}

async function init() {
  injectStore(store);
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Provider store={store}>
      <Notificaiton>
        <App />
      </Notificaiton>
    </Provider>,
  );

  // await registerServiceWorker();
  // await defeRender();
}

init();
